let config = {
  WEB: process.env.VUE_APP_WEB, //1平台 2鹰眼 3宗教 4公园 5厂房 6矩阵 7城市 8水域 9三保三优
};

if (process.env.NODE_ENV === 'development') {
  config = Object.assign(config, require('./dev'));
} else {
  config = Object.assign(config, require('./pro'));
}

module.exports = config;
module.exports.default = config;
